<template>
  <v-container fluid>
    <v-card flat class="rounded-lg pa-2" height="100%">
      <div class="rounded-lg pageTitle" style="width: 100%;">
        <v-toolbar-title style="font-weight:bold;">{{tables.area_info.title}}</v-toolbar-title>
      </div>
      <div class="rowDiv contentCenter mt-1">
        <div class="pa-1 ml-2 font-weight-black text-h5">{{tables.area_info.subtitle}}</div>
        <div class="pa-0"
          v-for="item in tables.area_info.areaList"
          v-bind:key="item.area_id"
        >
          <v-checkbox 
            dense
            hide-details
            v-model="tables.area_info.area_checked"
            :label="item.area_nm"
            :value="item.area_id"
            @click="tryGetRealTimeAlertPageData"
            v-show="item.area_id.indexOf('DUMMY') !== 0"
            class="mr-5 pt-0 mt-0"
            :disabled="!tables.site_info.isLoadingFinished"
          ></v-checkbox>
        </div>
        <v-spacer>
        </v-spacer>
      </div>
      <!-- 誤報 dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.event_info.dialogErrorEvent" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">誤報事件</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newModelInfoForm">
                <div class="rowDiv contentCenter" >
                  <div style="width:300px" class="ml-2">
                    <v-text-field
                      label="請輸入處理作業說明"
                      v-model="selectItem.remark"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeErrorEventDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="closeErrorEvent">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 查詢 dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.event_info.dialogSearchNM" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">查詢</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newModelInfoForm">
                <div class="rowDiv contentCenter" >
                  <div style="width:300px" class="ml-2">
                    <v-text-field
                      label="設備名稱"
                      v-model="tables.event_info.search.DeviceNM"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="tables.event_info.dialogSearchNM=false">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="getEventList">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit dialog -->
      <v-dialog overlay-opacity="0.2" max-width="1000px" v-model="tables.event_info.dialogEdit" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">即時警報監控</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newEditForm">
                <div class="rowDiv contentCenter" >
                  <div style="width:200px">
                    <v-text-field
                      label="設備名稱"
                      v-model="selectItem.device_nm"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="頻道"
                      v-model="selectItem.eventChn"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="警報時間"
                      v-model="selectItem.eventTime"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="警報狀態"
                      v-model="selectItem.statusCodeName"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:410px">
                    <v-textarea
                      label="處理作業說明"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      clear-icon="mdi-close-circle"
                      rows="3"
                      v-model="selectItem.remark"
                    ></v-textarea>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:150px">
                    <v-switch
                      class="ma-0 pa-0"
                      label="是否誤報"
                      v-model="selectItem.isErrorEvent"
                      hide-details
                      true-value="Y"
                      false-value="N"
                    >
                    </v-switch>
                  </div>
                  <div style="width:150px">
                    <v-switch
                      class="ma-0 pa-0"
                      label="處理完成"
                      v-model="selectItem.isClosed"
                      hide-details
                      true-value="Y"
                      false-value="N"
                    >
                    </v-switch>
                  </div>
                  <div style="width:180px">
                    <v-switch
                      class="ma-0 pa-0"
                      label="開啟人員標記"
                      v-show="selectItem.device_model != dialogs.const_model_thremal"
                      v-model="selectItem.personTag"
                      hide-details
                      true-value="Y"
                      false-value="N"
                    >
                    </v-switch>
                  </div>
                </div>
                <div class="mt-5 ContentCenter">
                  <div
                    class="background ml-auto mr-auto"
                    style="width: 640px; height: 360px; background-size: 100% 100%; position:relative;"
                  >
                    <img
                      :src="'data:image/png;base64,'+ dialogs.pic1"
                      contain
                      width="640px"
                      height="360px"
                      style="margin-left: auto;margin-right: auto;"
                    />
                    <canvas 
                      id="canvas"
                      @mouseup="mouseUp"
                      @mousedown="mouseDown"
                      @mousemove="mousemove"
                      width="640px" 
                      height="360px"
                      style="background-color: transparent;
                        cursor: crosshair;
                        position: absolute;z-index: 10;
                        left: -1px;
                        top: -1px;"
                    >
                    </canvas>
                  </div>
                  <div v-show="selectItem.picCount > 1"
                    class="background ml-auto mr-auto"
                    style="width: 640px; height: 360px; background-size: 100% 100%; position:relative;">
                    <img
                      :src="'data:image/png;base64,'+ dialogs.pic2"
                      contain
                      width="640px"
                      height="360px"
                      style="margin-left: auto;margin-right: auto;"
                    />
                  </div>
                  <div v-show="selectItem.picCount > 2"
                    class="background ml-auto mr-auto"
                    style="width: 640px; height: 360px; background-size: 100% 100%; position:relative;">
                    <img
                      :src="'data:image/png;base64,'+ dialogs.pic3"
                      contain
                      width="640px"
                      height="360px"
                      style="margin-left: auto;margin-right: auto;"
                    />
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeEdit">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveEdit">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增編輯device location dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.event_info.dialogDeviceLocation" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">區塊繪製設定</v-card-title>
          <v-card-text>
            <div class="mt-5 rowDiv">
              <div class="css_td">
                <fieldset class="pa-2" style="min-width: 200px;min-height:80px;">
                  <legend style="font-size: 20px; font-weight: bold; margin-left:20px">繪製對象</legend>
                  <v-btn-toggle
                    v-model="tables.device_location.drawTarget"
                    rounded
                    color="deep-purple-accent-3"
                    group
                    mandatory
                  >
                    <v-btn value="L" class="dialogbtn" v-if="dialogs.const_model_thremal!=selectItem.device_model">{{ dialogs.ai_location_name }}</v-btn>
                    <v-btn value="S" class="dialogbtn">{{ dialogs.di_location_name }}</v-btn>
                  </v-btn-toggle>
                </fieldset>
              </div>
              <div class="css_td ml-2">
                <fieldset class="pa-2" style="min-height:80px;width: 200px;">
                  <legend style="font-size: 20px; font-weight: bold; margin-left:20px">區塊清單</legend>
                  <div class="rowDiv">
                    <v-btn
                      v-for="(data, index) in tables.device_location.regionList"
                      :key="index" class="cancelBtnColor ma-1"
                      small
                      @click="selectRegion(tables.device_location.paintstatu, index)"
                    >
                      {{index}}
                    </v-btn>
                  </div>
                  <v-btn class="dialogbtn subBtnColor mt-2" @click="removeRegion">移除指定區塊</v-btn>
                </fieldset>
              </div>
              <div class="ml-2 css_td" id="ATool">
                <fieldset class="pa-2" style="min-width: 200px;min-height:80px;max-width: 500px;">
                  <legend style="font-size: 20px; font-weight: bold; margin-left:20px">AI設定功能</legend>
                  <div style="width:300px" class="rowDiv">
                    <v-select
                      :items="tables.model_info.data"
                      outlined
                      class="rounded-lg"
                      dense
                      v-model="selectItem.ai_model"
                      hide-details
                    >
                    </v-select>
                    <v-text-field
                      v-model="selectItem.ai_param"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectItem.isSendAIS2"
                      label="二次辨識"
                      dense
                      outlined
                      hide-details
                      :true-value="1"
                      :false-value="0"
                    >二次辨識</v-switch>
                  </div>
                  <v-btn class="dialogbtn subBtnColor mt-2" @click="tables.model_info.dialogAdd = true">新增模型</v-btn>
                  <v-btn class="dialogbtn subBtnColor mt-2 ml-2" @click="tables.model_info.dialogDelete=true">移除模型</v-btn>
                </fieldset>                
              </div>
            </div>
            <div class="mt-5 rowDiv">
              <div
                class="background"
                style="width: 800px; height: 600px; background-size: 100% 100%;"
                :style="{'background-image': tables.device_location.image}"
                >
                <canvas id="Mcanvas" width="800px" height="600px" @click="mouseLocationClick" @mousemove="mouseLocationMove"></canvas>
                <canvas id="canvasSave" width="800px" height="600px"></canvas>
                <canvas id="Scanvas" width="800px" height="600px"></canvas>
                <canvas id="Lcanvas" width="800px" height="600px"></canvas>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialogDeviceLocation">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="resetLocation">全部重設</v-btn>
            <v-btn class="dialogbtn subBtnColor ml-2" @click="saveDeviceLocation">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增編輯model info dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.model_info.dialogAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">新增 Model</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newModelInfoForm">
                <div class="rowDiv contentCenter" >
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="Model名稱"
                      v-model="tables.model_info.selectedData.model_name"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialogModelAdd">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="AddModel">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 刪除model info dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.model_info.dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除 Model</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-card-title class="headline justify-center font-weight-bold">是否確認是刪除 {{selectItem.ai_model}}</v-card-title>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="tables.model_info.dialogDelete=false">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteModel">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">警報列表</div>
        <div>
          <v-btn depressed color="success" class="btn_fontSize ml-2" @click="CloseSite">結案</v-btn>
        </div>
        <div class="rounded-lg ml-2">
          <v-toolbar-title class="ml-2" style="font-weight:bold;">- {{AlarmLoadingStatus}}</v-toolbar-title>
        </div>
        <v-spacer>
        </v-spacer>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.site_info.total}}筆
        </div>
      </div>
      <v-data-table
        :height="AlarmDisplayHeight"
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-header
        hide-default-footer
        :items="tables.site_info.data"
        :headers="tables.site_info.headers"
        :loading="!tables.site_info.isLoadingFinished"
        :items-per-page="tables.site_info.total"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.site_info.headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr @click="choseAlert(item)" :class="{'selectedRow': item.site_id === tables.site_info.selectedData.site_id}">
            <td v-for="header in tables.site_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value == 'area_id'">{{ tables.area_info.areaList.find(o => o.area_id == item[header.value]).area_nm}}</div>
              <div v-else>{{item[header.value]}}</div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
    </v-card>

    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">即時警報監控</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="CloseCaseBatch">整批結案</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="GetLiveViewUrl(1)">即時監控</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="GetLiveViewUrl(0)">影像回放</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="tables.event_info.dialogSearchNM=true">查詢{{ SearchDeviceName }}</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="getLastEventPic">偵測與遮蔽區塊設定</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.event_info.page"
            :length="tables.event_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.event_info.total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="tables.event_info.rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.event_info.rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.event_info.data"
        :headers="tables.event_info.headers"
        hide-default-header
        :items-per-page="tables.event_info.rows"
        :loading="tables.event_info.isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.event_info.headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  class="sortableThDiv"
                >
                  <div v-if="header.value === 'select'">
                    <v-checkbox
                      color="success"
                      style="margin: auto;"
                      hide-details
                      v-model="tables.event_info.allSelected"
                      @change="setAllSelected"
                    ></v-checkbox>
                  </div>
                  <div v-else class="sortableThDivText">
                    {{header.text}}
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr @click="selectItem=item" :class="{'selectedRow': item === selectItem}">
            <td v-for="header in tables.event_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value === 'select'">
                <v-checkbox
                  color="success"
                  style="margin: auto;"
                  hide-details
                  v-model="item.isSelected"
                  @chanage="checkAllSelected(item)"
                ></v-checkbox>
              </div>
              <div v-else-if="header.value === 'action'">
                <div class="rowDiv">
                  <div>
                    <v-btn depressed  color="blue" class="btn_fontSize ml-2" @click="SendMessage(item)">推播至客戶端</v-btn>
                  </div>
                  <div>
                    <v-btn depressed  color="orange" class="btn_fontSize ml-2" @click="CloseCase (item)">結案</v-btn>
                  </div>
                  <div>
                    <v-btn depressed  color="orange" class="btn_fontSize ml-2" @click="chooseErrorEvent(item)">誤報</v-btn>
                  </div>
                  <v-icon
                    class="ml-2"
                    size = "35"
                    color="primary"
                    style="cursor: pointer;"
                    @click="openEdit(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </div>
              </div>
              <div v-else-if="header.value === 'pic'">
                <img
                  :src="'data:image/png;base64,'+ item.pic"
                  contain
                  v-if="item.pic"
                  height="180px"
                  width="320px"
                  style="margin-left: auto;margin-right: auto;"
                />
                <div v-else>
                  無發報圖片
                </div>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
import HuntHelper from '../components/HuntHelper.js' // Import from the js location
import MDHelper from '../components/MDHelper.js' // Import from the js location
import RecHelper from '../components/RecHelper.js'
export default {
  name: 'Realtime_Alert_View',
  data: () => ({
    tables: {
      area_info: {
        urlGet: 'area_info/getPageData',
        title: '即時警報監控',
        subtitle: '管制區：',
        areaList: [],
        area_checked_timer: null,
        area_checked: [{area_id:'', area_nm:''}]
      },
      site_info: {
        urlGet: 'site_info/Get_Realtime_Alert',
        urlClose: '/site_info/CloseSite',
        rows: 10,
        sortItem: '',
        sortOrder: true,
        total: 0,
        pageCount: 0,
        page: 1,
        rowsList: [10, 20, 30, 40, 50],
        headers: [
          { text: '標的物編號', value: 'site_id', sortable: false },
          { text: '主機編號', value: 'site_mno', sortable: false },
          { text: '所屬管制區', value: 'area_id',  sortable: false },
          { text: '標的物名稱', value: 'site_nm',  sortable: false },
          { text: '標的物位置', value: 'site_location',  sortable: false },
          { text: '標的物聯絡人', value: 'site_person',  sortable: false },
          { text: '聯絡人電話', value: 'site_phone',  sortable: false },
          { text: '第一筆發報時間', value: 'firstalert',  sortable: false },
          { text: '發報狀態', value: 'firststatus',  sortable: false },
          { text: '最末筆發報時間', value: 'lastalert',  sortable: false },
          { text: '發報狀態', value: 'laststatus',  sortable: false },
        ],
        data: [],
        selectedData: {},
        search:{
          DeviceSiteId: ''
        },
        timer: null,
        countDown: 30,
        isLoadingFinished: true,
      },
      event_info: {
        isLoading: false,
        urlGet: 'site_info/Get_Event_List',
        urlLast: '/site_info/getLastEventPic',
        urlLocation: '/device_info/SaveALLLocation',
        urlGetDevice: 'device_info/FindDevice',
        urlSaveAlarm: '/site_info/SaveAlarmEdit',
        urlGetPic: '/site_info/GetEventPic',
        urlSend: '/site_info/SendAlarmMessage',
        urlCLose: '/site_info/CloseCase',
        urlError: '/site_info/CloseErrorEvent',
        rows: 10,
        sortItem: '',
        sortOrder: true,
        total: 0,
        pageCount: 0,
        page: 1,
        rowsList: [10, 20, 30, 40, 50],
        headers: [
          { text: '', value: 'select', sortable: false },
          { text: '', value: 'action', sortable: false },
          { text: '已推播', value: 'isSend', sortable: false },
          { text: '設備名稱', value: 'device_nm', sortable: false },
          { text: '設備位置', value: 'device_location', sortable: false },
          { text: '設備編號', value: 'deviceID', sortable: false },
          { text: '頻道', value: 'eventChn', sortable: false },
          { text: '警報', value: 'statusCodeName', sortable: false },
          { text: '狀態', value: 'alarmState', sortable: false },
          { text: '警報時間', value: 'eventTime', sortable: false },
          { text: '警報圖片', value: 'pic', sortable: false },
        ],
        data: [],

        
        dialogSearchNM: false,
        search: {
          DeviceNM: ''
        },
        allSelected: false,
        
        dialogErrorEvent: false,
        dialogDeviceLocation: false,
      },
      para_info: {
        urlGet: 'para_info/getPageData',
        startDelayTime: 0,
        endDelayTime: 0,
      },
      model_info: {
        urlGet: 'model_info/GetPageData',
        urlAdd: 'model_info/add',
        urlDelete: '/model_info/del',
        data: [],
        selectedData: {
          model_name: ''
        },
        
        dialogAdd: false,
        dialogEdit: false,
        dialogDelete: false,

        default_ai: '',
        default_di: '',
        default_model: 'model_v2',
        default_param: '0.5',
        default_isSendAIS2: 0,
      },
      device_location: {
        drawTarget: 'L',
        image: '',
        can: null,
        ctx: null,
        canSave: null,
        ctxSave: null,
        scan: null,
        sctx: null,
        lcan: null,
        lctx: null,

        pointX: 0,
        pointY: 0,
        regionSet: [],//存放所有操作中的區域
        pointArr: [],//存放坐标的數组
        selectedRegion: {},
        SelectedEdgeStyle: 'rgba(200,200,0,1)',  // 黃
        SelectedFillStyle: 'rgba(220,220,40,1)',
        DefaultFillStyle: 'rgba(161,195,255,1)',// 藍
        DefaultEdgeStyle: 'rgba(102,168,255,1)',
        LocationEdgeStyle: 'rgba(237,28,36,1)',  // 紅
        LocationFillStyle: 'rgba(230,36,55,1)',
        ShadeEdgeStyle: 'rgba(0,177,40,1)',   // 綠
        ShadeFillStyle: 'rgba(34,177,76,1)',
        LineWidth: 4, // 線條粗細
        GlobalAlpha: 0.8, // 透明度
        oIndex: -1, //判断鼠标是否移动到起始點处，-1為否，1為是
        paintstatu: '',
        regionList: [],
      }
    },
    dialogs: {
      pic1: '',
      pic2: '',
      pic3: '',

      isdown: 0,
      stouchX: 0,
      stouchY: 0,
      etouchX: 0,
      etouchY: 0,
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      const_model_thremal: 'AS-T5014RES-32F-2',

      ai_location_name: '偵測區塊',
      di_location_name: '遮蔽區塊',
      const_camera__ai_name: '偵測區塊',
      const_camera__di_name: '遮蔽區塊',
      const_thermal_ai_name: '',
      const_thermal_di_name: '測煙/測溫遮蔽區塊',
    },
    rules: {
      content: [v => !!v || 'Required']
    },
    dictionary: {
      statusCodeList: []
    },
    controlPermission: [],

    selectItem: '',
    
    MODE_ACtrl: false,
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.getAreaInfo(() => {
      this.setCountDown()
      this.getDictionary()
      this.getPageData()
      this.getModelInfo()
      this.getParaInfo()
    })
    
    if (this.user.funcLoader.indexOf('FUNC_CTRL_AI') >= 0) {
        this.MODE_ACtrl = true
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearCountDown()
    next()
  },
  watch: {
    "tables.event_info.page" () {
      this.getEventList()
    },
    "tables.event_info.rows" () {
      this.tables.event_info.page === 1 ? this.getEventList() : this.tables.event_info.page = 1
    },
    "tables.device_location.drawTarget" () {
      this.switchCanvas(this.tables.device_location.drawTarget)
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    },
    AlarmLoadingStatus() {
      if (this.tables.site_info.isLoadingFinished) {
        return this.tables.site_info.countDown + ' 秒後進行刷新'
      }
      else {
        return '讀取中'
      }
    },
    AlarmDisplayHeight() {
      // tables.site_info.data.length>=10?609:(tables.site_info.data.length+1)*56
      if (this.tables.site_info.data.length == 0) {
        return (this.tables.site_info.data.length + 2)*56
      } else {
        return this.tables.site_info.data.length>=10?609:(this.tables.site_info.data.length + 1)*56
      }
    },
    SearchDeviceName () {
      if (this.tables.event_info.search.DeviceNM.length > 0) {
        return ` (${this.tables.event_info.search.DeviceNM})`
      } else {
        return ''
      }
    }
  },
  methods: {
    showWaiting (isWaiting, msgWaiting) {
      this.$emit('setWaiting', { mWaiting: 0, isWaiting: isWaiting, msgWaiting: msgWaiting })
    },
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    setCountDown () {
      this.clearCountDown()
      this.tables.site_info.timer = setInterval(() => {
        this.tables.site_info.countDown--
        if (this.tables.site_info.countDown === 0) {
          this.getPageData()
        }
      }, 1000)
    },
    clearCountDown () {
      if (this.tables.site_info.timer) {
        clearInterval(this.tables.site_info.timer)
        this.tables.site_info.timer = null
      }
    },
    getDictionary () {
      let parm = ['es_status_code']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            let statusIndex = response.data.map(function (item) { return item.dicNo }).indexOf('es_status_code')
            let statusCodeList = response.data[statusIndex].data
            statusCodeList.forEach(element => {
              var status = {
                value: element.key,
                text: element.value
              }
              this.dictionary.statusCodeList.push(status)
            })
          }
        })
    },
    getPageData () {
      // 檢查前次查詢是否已完成
      if (!this.tables.site_info.isLoadingFinished) {
        return
      }

      // 標記本次查詢開始
      this.tables.site_info.isLoadingFinished = false

      var searchAreaNm = {
        name: 'area_id_filter',
        value: this.tables.area_info.area_checked.join(','),
        displayType: 'IN'
      }
      var wheres = [searchAreaNm]
      var parm = {
        page: 1,
        rows: 10,
        order: 'asc',
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.site_info.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.site_info.data = response.data.data
            this.tables.site_info.total = this.tables.site_info.data.length
          }
        }).finally(()=>{
          // 標記本次查詢已完成
          this.tables.site_info.isLoadingFinished = true
          this.tables.site_info.countDown = 60
      })
    },
    choseAlert (item) {
      this.tables.site_info.selectedData = item
      this.tables.site_info.search.DeviceSiteId = item.site_id
      this.getEventList()
    },
    getEventList () {
      this.tables.event_info.isLoading = true
      this.tables.event_info.data = []
      var wheres = []
      wheres.push({
        name: 'site_id',
        value: this.tables.site_info.search.DeviceSiteId,
        displayType: 'like'
      })
      wheres.push({
        name: 'device_nm',
        value: this.tables.event_info.search.DeviceNM,
        displayType: 'like'
      })
      var parm = {
        page: this.tables.event_info.page,
        rows: this.tables.event_info.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.event_info.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.event_info.dialogSearchNM = false
            this.tables.event_info.data = response.data.data.ds
            this.tables.event_info.total = response.data.data.scalar
            this.tables.event_info.pageCount = Math.ceil(this.tables.event_info.total / this.tables.event_info.rows)
            this.$nextTick(() => {
              this.tables.event_info.data.forEach(element => {
                element.isErrorEvent = "N"
                element.isClosed = "N"
                let status = this.dictionary.statusCodeList.find(x =>x.value === element.statusCode)
                if (status) {
                  element.statusCodeName = status.text
                }
                element.isSelected = false
                // element.pic = this.getEventPic(element)
                if (element.picCount!==0 && element.alarmID.length>0) {
                  this.getEventPic(element)
                }
              })
            })
          }
        })
      .finally(() => {
        this.tables.event_info.isLoading = false
      })
    },
    getEventPic (item) {
      // return item.alarmID
      let url = this.tables.event_info.urlGetPic
      let pic = ''
      Service.updateData({ alarmID: item.alarmID, width: 320, height: 180 }, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            // this.showAlert('error', response.data.message)
            pic = 'ERROR'
          } else {
            pic = response.data.data
            this.$set(item,'pic',pic)
          }
        })
    },
    chooseErrorEvent (item) {
      this.selectItem = item
      this.tables.event_info.dialogErrorEvent = true
    },
    closeErrorEventDialog () {
      this.selectItem = ''
      this.tables.event_info.dialogErrorEvent = false
    },
    closeErrorEvent () {
      var url = this.tables.event_info.urlError
      Service.updateData(this.selectItem, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.getEventList()
            this.closeErrorEventDialog()
          }
        })
    },
    CloseCase (item) {
      var url = this.tables.event_info.urlCLose
      item.remark = ''
      Service.updateData(item, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.getEventList()
          }
        })
    },
    CloseSite () {
      if (this.tables.site_info.selectedData.site_id === undefined) {
        this.showAlert('error', '請先選擇標的物')
        return
      }
      if (confirm('是否進行結案作業')) {
        var url = this.tables.site_info.urlClose
        this.tables.site_info.selectedData.remark = ''
        Service.updateData(this.tables.site_info.selectedData, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getEventList()
            }
          })
      }
    },
    setAllSelected () {
      if (this.tables.event_info.allSelected) {
        this.tables.event_info.data.forEach(element => {
          element.isSelected = true
        })
      } else {
        this.tables.event_info.data.forEach(element => {
          element.isSelected = false
        })
      }
    },
    checkAllSelected (item) {
      if (!item.isSelected) {
        this.tables.event_info.allSelected = false
      }
    },
    CloseCaseBatch () {
      if (this.tables.event_info.data.length == 0) {
        this.showAlert('error', '請先選擇警報事件')
        return
      }
      let seqnos = []
      let table_nm = ''
      this.tables.event_info.data.forEach(element => {
        if (element.isSelected) {
          seqnos.push(element.seqNo)
          table_nm = element.table_nm
        }
      })
      this.CloseCase({ table_nm : table_nm, remark: '', seqNo: seqnos.join(',')})
    },
    SendMessage (item) {
      var url = this.tables.event_info.urlSend
      Service.updateData(item, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
          }
        })
    },
    openEdit (item) {
      this.selectItem = item
      this.tables.event_info.dialogEdit = true
      
      setTimeout(() => {
        for(let index = 0; index < this.selectItem.picCount; ++index) {
          this.getPicData(this.selectItem, index)
        }
      }, 333);
    },
    closeEdit () {

      let canvas = document.querySelector('#canvas');
      let context = canvas.getContext("2d")
      var image = new Image()
      image.onload = function () {
        canvas.width = image.width
        canvas.height = image.height
        context.drawImage(image, 0, 0)
      }
      const NOT_FOUND_IMAGE = "iVBORw0KGgoAAAANSUhEUgAAAoAAAAFoCAIAAABIUN0GAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAVfSURBVHhe7dUxAQAwEAOh+jeduvhbwARvAMA5AQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAJzbPpetEZ8DE8ouAAAAAElFTkSuQmCC"
      image.src = "data:image/png;base64," + NOT_FOUND_IMAGE

      this.selectItem = ''
      this.tables.event_info.dialogEdit = false
      // 暫時特別重取頁面資料
      this.getEventList()
    },
    getPicData (item, index = 0) {
      var url = this.tables.event_info.urlGetPic
      
      const NOT_FOUND_IMAGE = "iVBORw0KGgoAAAANSUhEUgAAAoAAAAFoCAIAAABIUN0GAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAVfSURBVHhe7dUxAQAwEAOh+jeduvhbwARvAMA5AQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAAQEDAABAQNAQMAAEBAwAJzbPpetEZ8DE8ouAAAAAElFTkSuQmCC"
      let ui_operation = index == 0 && (item.device_model != this.dialogs.const_model_thremal)

      Service.updateData({ alarmID: item.alarmID, width: 640, height: 360, index: index }, url)
        .then((response) => {
          // loading
          let failed_response = response.status !== 200 || !response.data.status
          switch(index) {
            case 2:
              this.dialogs.pic3 = failed_response ? NOT_FOUND_IMAGE : response.data.data
            break
            case 1:
              this.dialogs.pic2 = failed_response ? NOT_FOUND_IMAGE : response.data.data
            break
            case 0:{
              this.dialogs.pic1 = failed_response ? NOT_FOUND_IMAGE : response.data.data
              // setting
              let canvas = document.querySelector('#canvas');
              let context = canvas.getContext("2d")
              context.clearRect(0, 0, canvas.width, canvas.height)

              if (item.personTag === 'Y' &&  this.selectItem.personStartPoint !== '' &&  this.selectItem.personEndPoint !== '') {
                  let words =  this.selectItem.personStartPoint.split(',')
                  let sx = words[0]
                  let sy = words[1]
                  words =  this.selectItem.personEndPoint.split(',')
                  let ex = words[0]
                  let ey = words[1]
                  context.strokeStyle = "#0000FF"
                  context.strokeRect(sx, sy, ex - sx, ey - sy)
                }

                if (ui_operation)  {
                  canvas.addEventListener('touchstart', function (event) {
                    if (item.personTag === 'Y') {
                        this.dialogs.isdown = 1
                        let R = canvas.getBoundingClientRect()
                        this.dialogs.stouchX = Math.round(event.touches[0].clientX - R.left)
                        this.dialogs.stouchY = Math.round(event.touches[0].clientY - R.top)
                    }
                  }, false)

                  canvas.addEventListener('touchend', function (event) {
                    if (item.personTag === 'Y') {
                        this.dialogs.isdown = 0
                        let R = canvas.getBoundingClientRect()
                        this.dialogs.etouchX = Math.round(event.changedTouches[0].clientX - R.left)
                        this.dialogs.etouchY = Math.round(event.changedTouches[0].clientY - R.top)
                        
                        this.selectItem.personStartPoint = (this.dialogs.stouchX + ',' + this.dialogs.stouchY);
                        this.selectItem.personEndPoint = (this.dialogs.etouchX + ',' + this.dialogs.etouchY);

                        context.clearRect(0, 0, canvas.width, canvas.height)
                        context.strokeStyle = "#0000FF"
                        context.strokeRect(this.dialogs.stouchX, this.dialogs.stouchY, this.dialogs.etouchX - this.dialogs.stouchX, this.dialogs.etouchY - this.dialogs.stouchY);
                    }
                  }, false);
                }
              }
            break
            
          }
        })
    },
    mouseDown(e) {
        if (this.selectItem.personTag === 'Y') {
            this.dialogs.isdown = 1
            // this.down_id = e.id
            this.dialogs.startX = e.offsetX
            this.dialogs.startY = e.offsetY
        }
    },
    mousemove(e) {
      if (this.selectItem.personTag === 'Y') {
        if (this.dialogs.isdown == 1) {
          // TOO MUCH FLASH
          var canvas = document.querySelector("#canvas")
          var context = canvas.getContext("2d")

          context.clearRect(0, 0, canvas.width, canvas.height)
          context.strokeStyle = "#0000FF"
          context.strokeRect(Math.min(this.dialogs.startX,e.offsetX), Math.min(this.dialogs.startY,e.offsetY), Math.abs(this.dialogs.startX - e.offsetX), Math.abs(this.dialogs.startY - e.offsetY));
        }
      }
    },
    mouseUp(e) {
      if (this.selectItem.personTag === 'Y') {
          this.dialogs.isdown = 0
          this.dialogs.endX = Math.max(this.dialogs.startX,e.offsetX)
          this.dialogs.endY = Math.max(this.dialogs.startY,e.offsetY)
          this.dialogs.startX = Math.min(this.dialogs.startX,e.offsetX)
          this.dialogs.startY = Math.min(this.dialogs.startY,e.offsetY)
          
          this.selectItem.personStartPoint = ( this.dialogs.startX + ',' +  this.dialogs.startY)
          this.selectItem.personEndPoint = (this.dialogs.endX + ',' + this.dialogs.endY)

          var canvas = document.querySelector("#canvas")
          var context = canvas.getContext("2d")
          context.clearRect(0, 0, canvas.width, canvas.height)
          context.strokeStyle = "#0000FF"
          context.strokeRect(this.dialogs.startX, this.dialogs.startY, (this.dialogs.endX - this.dialogs.startX), (this.dialogs.endY - this.dialogs.startY));
      }
    },
    saveEdit () {
      // console.log(this.selectItem)
      var url = this.tables.event_info.urlSaveAlarm
      Service.updateData(this.selectItem, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.closeEdit()
          }
        })
    },
    getLastEventPic () {
      if (this.selectItem.deviceID === undefined || this.selectItem.deviceID === '') {
        this.showAlert('error', '請先選擇裝置')
        return
      }
      // console.log(this.selectItem)
      let url = this.tables.event_info.urlLast
      Service.updateData({ deviceID : this.selectItem.deviceID, deviceChn: this.selectItem.eventChn, deviceModel: this.selectItem.device_model }, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              // this.showAlert('success', response.data.message)
              // console.log(response.data.data)
              if (response.data.data !== 'N') {
                this.getDeviceInfo(()=>{
                  this.tables.event_info.dialogDeviceLocation = true
                  this.setShade()
                })
                
                this.tables.device_location.image = "url(data:image/png;base64," + response.data.data + ")"

              } else {
                this.showAlert('error', '未搜尋到設備圖片')
              }
            }
          })
    },
    getDeviceInfo (callback) {
      var parm = {
        site_id: this.selectItem.siteID,
        device_id: this.selectItem.deviceID,
        eventChn: this.selectItem.eventChn
      }
      Service.updateData(parm, this.tables.event_info.urlGetDevice)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            var device = response.data.data
            this.selectItem.deviceID_upt= device.device_id
            this.selectItem.ai_model    = device.ai_model
            this.selectItem.ai_param    = device.ai_param
            this.selectItem.isSendAIS2  = device.isSendAIS2
            this.selectItem.backend_ai_audio   = device.backend_ai_audio
            this.selectItem.device_ai_location = device.device_ai_location
            this.selectItem.device_di_location = device.device_di_location
            if(callback) callback()
          }
        })
    },
    setShade () {
      this.$nextTick(() => {
        this.tables.device_location.can = document.getElementById("Mcanvas")
        this.tables.device_location.canSave = document.getElementById("canvasSave")
        this.tables.device_location.scan = document.getElementById("Scanvas")
        this.tables.device_location.lcan = document.getElementById("Lcanvas")
        this.tables.device_location.ctx = this.tables.device_location.can.getContext('2d')
        this.tables.device_location.ctxSave = this.tables.device_location.canSave.getContext('2d')
        this.tables.device_location.sctx = this.tables.device_location.scan.getContext('2d')
        this.tables.device_location.lctx = this.tables.device_location.lcan.getContext('2d')

        this.tables.device_location.ctx.strokeStyle = this.tables.device_location.DefaultEdgeStyle//線条颜色
        this.tables.device_location.ctx.lineWidth = this.tables.device_location.LineWidth
        this.tables.device_location.ctx.globalAlpha = this.tables.device_location.GlobalAlpha
        this.tables.device_location.ctxSave.strokeStyle = this.tables.device_location.DefaultEdgeStyle//線条颜色
        this.tables.device_location.ctxSave.lineWidth = this.tables.device_location.LineWidth
        this.tables.device_location.ctxSave.globalAlpha = this.tables.device_location.GlobalAlpha

        this.tables.device_location.sctx.clearRect(0, 0, this.tables.device_location.lcan.width, this.tables.device_location.lcan.height)
        this.tables.device_location.lctx.clearRect(0, 0, this.tables.device_location.lcan.width, this.tables.device_location.lcan.height)
        // this.clearLocation()
      })

      this.dialogs.ai_location_name = (this.dialogs.const_model_thremal == this.selectItem.device_model) 
        ? this.dialogs.const_thermal_ai_name
        : this.dialogs.const_camera__ai_name
      this.dialogs.di_location_name = (this.dialogs.const_model_thremal == this.selectItem.device_model) 
        ? this.dialogs.const_thermal_di_name
        : this.dialogs.const_camera__di_name
      this.tables.device_location.drawTarget = 'L'
      this.switchCanvas('L')
    },
    switchCanvas (type) {
      this.tables.device_location.selectedRegion = {}
      this.tables.device_location.paintstatu = type
      // console.log(type)
      // 修正熱成像 device_ai_location, device_di_location 為相同的值
      if (this.dialogs.const_model_thremal === this.selectItem.device_model) {
        this.selectItem.device_ai_location = ''
      }

      this.tables.event_info.default_ai = this.selectItem.device_ai_location
      this.tables.event_info.default_di = this.selectItem.device_di_location
      this.tables.event_info.default_model = this.selectItem.ai_model
      this.tables.event_info.default_param = this.selectItem.ai_param
      this.tables.event_info.default_isSendAIS2  = this.selectItem.isSendAIS2

      this.$nextTick(() => {
        if (this.MODE_ACtrl) {
          document.getElementById("ATool").style.display = "display"
        }
        else {
          document.getElementById("ATool").style.display = "none"
        }
      })
      // 遮蔽區
      var shadeSet = []
      if (this.tables.event_info.default_di != "" && this.tables.event_info.default_di != null) {
        shadeSet = this.parseFormat(this.tables.event_info.default_di)
        // console.log(shadeSet)
        this.$nextTick(() => {
          this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, shadeSet, 'S')
        })        
      }
      else {
        this.makeRegionList([], 'S')
        this.$nextTick(() => {
          this.tables.device_location.sctx.clearRect(0, 0, this.tables.device_location.scan.width, this.tables.device_location.scan.height)
        })
      }
      // 偵測區
      var locationSet = []
      if (this.tables.event_info.default_ai != "" && this.tables.event_info.default_ai != null) {
        locationSet = this.parseFormat(this.tables.event_info.default_ai)
        // console.log(locationSet)
        this.$nextTick(() => {
          this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, locationSet, 'L')
        })       
      }
      else {
        this.makeRegionList([], 'L')
        this.$nextTick(() => {
          this.tables.device_location.lctx.clearRect(0, 0, this.tables.device_location.lcan.width, this.tables.device_location.lcan.height)
        })        
      }
      // 操作區
      this.clearLocation();

      if (this.tables.device_location.paintstatu == 'S') {
        this.tables.device_location.regionSet = shadeSet;
      }
      else {
        this.tables.device_location.regionSet = locationSet;
      }
      // console.log(this.tables.device_location.regionSet)
    },
    clearLocation () {
      this.$nextTick(() => {
        this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height)
        this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.canSave.width, this.tables.device_location.canSave.height)
      })  
      this.tables.device_location.regionSet = []
      this.ointArr = []
    },
    parseFormat(data) {
      var rs = []
      var splitarea = data.split('$')
      for (var j = 0; j < splitarea.length; j++) {
        var splitdata = splitarea[j].split('@')
        var splitpoint = ""

        var subRegion = []
        for (var i = 1; i < splitdata.length; i++) {
          splitpoint = splitdata[i].split('#')
          var piX = splitpoint[0]
          var piY = splitpoint[1]
          subRegion.push({
              x: piX, y: piY
          })
        }
        rs.push(subRegion)
      }
      return rs
    },
    formFormat (_regionSet, type) {
      var tmpstr = ""
      for (var index = 0; index < _regionSet.length; ++index) {
        var subRegion = _regionSet[index]

        if (index == 0) tmpstr += subRegion.length
        else tmpstr += "$" + subRegion.length

        for (var i = 0; i < subRegion.length; i++) {
          tmpstr += "@" + parseInt(subRegion[i].x) + "#" + parseInt(subRegion[i].y)
        }
      }

      if (type === 'S') {
        // this.tables.event_info.default_di = tmpstr
        this.selectItem.device_di_location = tmpstr
      }
      else {
        // this.tables.event_info.default_ai = tmpstr
        this.selectItem.device_ai_location = tmpstr
      }
    },
    drawCanvas(context, canvas, dataSet, type, hl_index, hl_type) {
      // console.log(dataSet)
      // console.log(hl_type + ' - ' + hl_index)
      context.clearRect(0, 0, canvas.width, canvas.height)

      var edge = this.tables.device_location.LocationEdgeStyle
      var fill = this.tables.device_location.LocationFillStyle
      if (type === 'S') {
        edge = this.tables.device_location.ShadeEdgeStyle
        fill = this.tables.device_location.ShadeFillStyle
      }
      context.strokeStyle = edge//線条颜色
      context.fillStyle   = fill//填充颜色
      context.lineWidth   = this.tables.device_location.LineWidth//線条粗细
      context.globalAlpha = this.tables.device_location.GlobalAlpha

      if (type === this.tables.device_location.paintstatu) {
        // console.log('test')
        this.makeRegionList(dataSet, type)
        // this.$nextTick (() => {
        //   this.makeRegionList(dataSet, type)
        // })
      }

      context.clearRect(0, 0, canvas.width, canvas.height)
      for (var index = 0; index < dataSet.length; ++index) {

        if (hl_type && hl_index === index) {
          // 標記選擇內框色
          context.fillStyle   = this.tables.device_location.SelectedEdgeStyle
          context.strokeStyle = this.tables.device_location.SelectedFillStyle
        }
        else {
          context.fillStyle   = fill
          context.strokeStyle = edge
        }
        context.beginPath();

        var subRegion = dataSet[index]
        // console.log(subRegion)
        context.moveTo(subRegion[0].x, subRegion[0].y)
        for (var i = 1; i < subRegion.length; i++) {
          context.lineTo(subRegion[i].x, subRegion[i].y)
        }

        context.closePath()
        context.fill()
        context.stroke()//繪製
      }

      this.tables.device_location.pointArr = []
      // console.log(this.tables.device_location.regionSet)
    },
    makeRegionList(dataSet) {
      this.tables.device_location.regionList = dataSet
    },
    selectRegion(type, index) {
      // console.log('selectRegion')
      // console.log(type)
      // console.log(index)
      // console.log(this.tables.device_location.regionSet)
      this.tables.device_location.selectedRegion.type = type;
      this.tables.device_location.selectedRegion.index = index;

      if (type === 'S') {
        this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S', index, 'S');
      }
      else {
        this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L', index, 'L');
      }
    },
    removeRegion() {
      if (this.tables.device_location.selectedRegion.type && this.tables.device_location.selectedRegion.type === this.tables.device_location.paintstatu) {
        this.tables.device_location.regionSet.splice(this.tables.device_location.selectedRegion.index, 1)
        this.tables.device_location.selectedRegion = {}
        this.formFormat(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)
        if (this.tables.device_location.paintstatu === 'S') {
          this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S')
        }
        else {
          this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L')
        }
      }
      else {
        this.tables.device_location.selectedRegion = {}
      }
    },
    mouseLocationClick (e) {
      if (e.offsetX || e.layerX) {
        var max = 1
        if (this.tables.device_location.paintstatu === 'L') {
          max = 1
        }
        else {
          if (this.dialogs.const_model_thremal == this.selectItem.device_model) {
            max = 1
          } 
          else if (this.MODE_ACtrl) {
            max = -1
          }
          else {
            max = 1
          }
        }
        if (this.tables.device_location.regionSet.length == max) {
          return;
        }
        this.tables.device_location.pointX = e.offsetX == undefined ? e.layerX : e.offsetX
        this.tables.device_location.pointY = e.offsetY == undefined ? e.layerY : e.offsetY
        var piX, piY;
        if (this.tables.device_location.oIndex > 0 && this.tables.device_location.pointArr.length > 0) {
            // 結尾
          piX = this.tables.device_location.pointArr[0].x
          piY = this.tables.device_location.pointArr[0].y
          //画點
          //makearc(tables.device_location.ctx, piX, piY, GetRandomNum(2, 2), 0, 180, tables.device_location.DefaultEdgeStyle);
          this.tables.device_location.pointArr.push({
              x: piX, y: piY
          });

          this.tables.device_location.regionSet.push(this.tables.device_location.pointArr)
          this.makeRegionList(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)

          this.formFormat(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)
          if (this.tables.device_location.paintstatu === 'S') {
            this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S')
          }
          else {
            this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L')
          }

          this.tables.device_location.pointArr = []
          this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height)
          this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.canSave.width, this.tables.device_location.canSave.height)
        } else {
          // 產生中間點
          piX = this.tables.device_location.pointX
          piY = this.tables.device_location.pointY
          this.makearc(this.tables.device_location.ctx, piX, piY, this.GetRandomNum(2, 2), 0, 180, this.tables.device_location.DefaultEdgeStyle)
          this.tables.device_location.pointArr.push({
              x: piX, y: piY
          })
          this.canvasSave(this.tables.device_location.pointArr);//保存點線同步到另一个canvas

          if (this.tables.device_location.pointArr.length == 8) { //最多8點
            piX = this.tables.device_location.pointArr[0].x
            piY = this.tables.device_location.pointArr[0].y
            //画點
            //makearc(tables.device_location.ctx, piX, piY, GetRandomNum(2, 2), 0, 180, tables.device_location.DefaultEdgeStyle);
            this.tables.device_location.pointArr.push({
                x: piX, y: piY
            });
            this.tables.device_location.regionSet.push(this.tables.device_location.pointArr)
            this.makeRegionList(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)

            this.formFormat(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)
            if (this.tables.device_location.paintstatu === 'S') {
              this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S')
            }
            else {
              this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L')
            }

            this.tables.device_location.pointArr = []
            this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height)
            this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.canSave.width, this.tables.device_location.canSave.height)
          }
        }
      }
    },
    mouseLocationMove (e) {
      if (e.offsetX || e.layerX) {
        this.tables.device_location.pointX = e.offsetX == undefined ? e.layerX : e.offsetX;
        this.tables.device_location.pointY = e.offsetY == undefined ? e.layerY : e.offsetY;
        var piX, piY;
        /*清空画布*/
        this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height);
        /*鼠标下跟随的圆點*/
        this.makearc(this.tables.device_location.ctx, this.tables.device_location.pointX, this.tables.device_location.pointY, this.GetRandomNum(4, 4), 0, 180, this.tables.device_location.DefaultEdgeStyle);

        if (this.tables.device_location.pointArr.length > 0) {
          if ((this.tables.device_location.pointX > this.tables.device_location.pointArr[0].x - 15 && this.tables.device_location.pointX < this.tables.device_location.pointArr[0].x + 15) && (this.tables.device_location.pointY > this.tables.device_location.pointArr[0].y - 15 && this.tables.device_location.pointY < this.tables.device_location.pointArr[0].y + 15)) {
            if (this.tables.device_location.pointArr.length > 1) {

              piX = this.tables.device_location.pointArr[0].x;
              piY = this.tables.device_location.pointArr[0].y;
              this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height);
              this.makearc(this.tables.device_location.ctx, piX, piY, this.GetRandomNum(4, 4), 0, 180, this.tables.device_location.DefaultEdgeStyle);
              this.tables.device_location.oIndex = 1;
            }
          } else {
            piX = this.tables.device_location.pointX;
            piY = this.tables.device_location.pointY;
            this.tables.device_location.oIndex = -1;
          }
            /*開始繪製*/
          this.tables.device_location.ctx.beginPath();
          this.tables.device_location.ctx.moveTo(this.tables.device_location.pointArr[0].x, this.tables.device_location.pointArr[0].y);
          if (this.tables.device_location.pointArr.length > 1) {
            for (var i = 1; i < this.tables.device_location.pointArr.length; i++) {
              this.tables.device_location.ctx.lineTo(this.tables.device_location.pointArr[i].x, this.tables.device_location.pointArr[i].y);
            }
          }
          this.tables.device_location.ctx.lineTo(piX, piY);
          this.tables.device_location.ctx.fillStyle = this.tables.device_location.DefaultFillStyle;//填充颜色
          this.tables.device_location.ctx.fill();//填充
          this.tables.device_location.ctx.stroke();//繪製
        }
      }
    },
    // 存储已生成的點線
    canvasSave(pointArray) {
      this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.ctxSave.width, this.tables.device_location.ctxSave.height);
      this.tables.device_location.ctxSave.beginPath();
      if (pointArray.length > 1) {
        this.tables.device_location.ctxSave.moveTo(pointArray[0].x, pointArray[0].y);
        for (var i = 1; i < pointArray.length; i++) {

          this.tables.device_location.ctxSave.lineTo(pointArray[i].x, pointArray[i].y);
          this.tables.device_location.ctxSave.fillStyle = this.tables.device_location.DefaultFillStyle;//填充颜色
          //tables.device_location.ctxSave.fill();
          this.tables.device_location.ctxSave.stroke();//繪製
        }
        this.tables.device_location.ctxSave.closePath();
      }
    },
    /*生成画布 結束绘画*/
    saveCanvas() {
      this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height);
      this.tables.device_location.ctxSave.closePath();//結束路徑狀態，結束當前路徑，如果是一个未封闭的圖形，會自動將首尾相連封闭起来
      this.tables.device_location.ctxSave.fill();//填充
      this.tables.device_location.ctxSave.stroke();//繪製
      this.tables.device_location.pointArr = [];
    },
    /*验证canvas画布是否為空函數*/
    isCanvasBlank(canvas) {
      var blank = document.createElement('canvas');//创建一个空canvas对象
      blank.width = canvas.width;
      blank.height = canvas.height;
      return canvas.toDataURL() == blank.toDataURL();//為空 返回true
    },
    /*canvas生成圆點*/
    GetRandomNum(Min, Max) {
      var Range = Max - Min;
      var Rand = Math.random();
      return (Min + Math.round(Rand * Range));
    },
    makearc(ctx, x, y, r, s, e, color) {
      ctx.clearRect(0, 0, 199, 202);//清空画布
      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.arc(x, y, r, s, e);
      ctx.fill();
    },
    closeDialogDeviceLocation () {
      this.tables.event_info.dialogDeviceLocation = false
      this.tables.event_info.default_model = 'model_v2'
      this.tables.event_info.default_param = '0.5'
      this.tables.event_info.default_isSendAIS2 = '0.5'
    },
    resetLocation () {
      // console.log(this.tables.event_info.default_di)
      this.selectItem.device_ai_location = this.tables.event_info.default_ai
      this.selectItem.device_di_location = this.tables.event_info.default_di
      this.selectItem.ai_model    = this.tables.event_info.default_model
      this.selectItem.ai_param    = this.tables.event_info.default_param
      this.selectItem.isSendAIS2  = this.tables.event_info.default_isSendAIS2
      this.tables.device_location.drawTarget = 'L'
      this.switchCanvas('L')
    },
    saveDeviceLocation () {
      var url = this.tables.event_info.urlLocation
      this.selectItem.site_id = this.selectItem.siteID
      // 修正熱成像 device_ai_location, device_di_location 為相同的值
      if (this.dialogs.const_model_thremal === this.selectItem.device_model) {
        this.selectItem.device_ai_location = this.selectItem.device_di_location
      }
      Service.updateData(
        {
          site_id: this.selectItem.siteID,
          device_id: this.selectItem.deviceID_upt,
          device_ai_location: this.selectItem.device_ai_location,
          device_di_location: this.selectItem.device_di_location,
          ai_model: this.selectItem.ai_model,
          ai_param: this.selectItem.ai_param,
          isSendAIS2: this.selectItem.isSendAIS2,
        },
        url
      ).then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.closeDialogDeviceLocation()
          }
        })
    },
    getModelInfo () {
      this.tables.model_info.data = []
      var wheres = []      
      var parm = {
        page: this.sitePage,
        rows: 10,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.model_info.urlGet
      }
      Service.getPageData(parm, true)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            response.data.rows.forEach(element => {
              var model = {
                id: element.SeqNo,
                text: element.model_name,
                value: element.model_name
              }
              this.tables.model_info.data.push(model)
            })
            // console.log(this.tables.model_info.data)
          }
        })
    },
    closeDialogModelAdd () {
      this.tables.model_info.dialogAdd = false
      if (this.$refs.newModelInfoForm) {
        this.$refs.newModelInfoForm.resetValidation()
        this.tables.model_info.selectedData = {
          model_name: ''
        }
      }
    },
    AddModel () {
      if (this.$refs.newModelInfoForm.validate()) {
        Service.updateData(this.tables.model_info.selectedData, this.tables.model_info.urlAdd)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getModelInfo()
              this.closeDialogModelAdd()
            }
          })
      }
    },
    deleteModel () {
      if (this.tables.model_info.data.length === 1) {
        this.showAlert('error', '模型列表不足無法刪除')
        return
      }
      let model = this.tables.model_info.data.find(x => x.text === this.selectItem.ai_model)
      if (model) {
        let deleteList = []
        deleteList.push(model.id)
        Service.deleteData(deleteList, this.tables.model_info.urlDelete)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getModelInfo()
              this.selectItem.ai_model = 'model_v2'
              this.tables.model_info.dialogDelete = false
            }
          })
      }else {
        this.showAlert('error', '無法刪除')
      }
    },
    GetLiveViewUrl (type) {
      if (this.selectItem.deviceID === '' || this.selectItem.deviceID === undefined) {
        this.showAlert('error', '請先選擇裝置')
        return
      }
      if (type=='0' && this.selectItem.device_kind =='HT') {
        this.showAlert('error', '目前不支援 HT 回放')
        return
      }
      let time = new Date(this.selectItem.eventTime)
      let startTime = time.setSeconds(time.getSeconds() - this.tables.para_info.startDelayTime)
      let endTime = time.setSeconds(time.getSeconds() + this.tables.para_info.endDelayTime)

      this.showWaiting(true, '等待連線中...')
      Service.GetLiveViewUrl({ device_id : this.selectItem.deviceID, site_id: this.selectItem.siteID })
        .then((response) => {
          this.showWaiting(false, '')
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            let accessType = response.data.data.accessType
            let kind = response.data.data.kind
            let deviceType = response.data.data.type
            let paraList = response.data.data.para.split(';')
            if (paraList[0] === 'N') {
              this.showAlert('error', '目前不支援P2P連線')
            } else if (kind=='HT') {
              paraList.push(type)
              HuntHelper.SetClearFunction(this)
              HuntHelper.OpenWindow(this, paraList, accessType)
            } else if (kind=='SS' && deviceType === 'AI_REC') {
              paraList.push(type)
              paraList.push(this.selectItem.eventChn) // default channel
              paraList.push(this.getdtformat(startTime))
              paraList.push(this.getdtformat(endTime))
              RecHelper.SetClearFunction(this)
              RecHelper.OpenWindow(this, paraList, accessType)
            } else if (kind=='MD' && deviceType === 'AI_HUB') {
              paraList.push(type)
              paraList.push(this.selectItem.eventChn) // default channel
              paraList.push(this.getdtformat(startTime))
              paraList.push(this.getdtformat(endTime))
              MDHelper.SetClearFunction(this)
              MDHelper.OpenWindow(this, paraList, accessType)
            } else {
              paraList.push(type)
              paraList.push(this.getdtformat(startTime))
              paraList.push(this.getdtformat(endTime))
              this.$store.commit('setRouteParam', paraList)
              this.$store.commit('setAccessType', accessType)
              const routeData = this.$router.resolve({name: 'CameraFunc'})
              window.open(routeData.href, 'Shinsoft', 'height=760,width=660,menubar=no,resizable=no,status=no,toolbar=no,location=no,scrollbars=no')
            }
          }
        });
    },
    getParaInfo () {
      var wheres = []
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.para_info.urlGet
      }
      Service.getPageData(parm, true)
        .then((response) => {
          // og(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            let paraList = response.data.rows
            this.tables.para_info.startDelayTime = paraList.find(x => x.para_caption === '回放前間隔幾秒').para_value
            this.tables.para_info.endDelayTime = paraList.find(x => x.para_caption === '回放後間隔幾秒').para_value
          }
        })
    },
    getdtformat(date_) {
        date_ = new Date(date_)
        var year = "" + date_.getFullYear()
        var month = date_.getMonth() + 1
        var day = date_.getDate()
        if (month < 10) month = "0" + month
        else month = "" + month
        if (day < 10) day = "0" + day
        else day = "" + day

        var hours = date_.getHours()
        var mins = date_.getMinutes()
        var secs = date_.getSeconds()
        if (hours < 10) hours = "0" + hours
        else hours = "" + hours
        if (mins < 10) mins = "0" + mins
        else mins = "" + mins
        if (secs < 10) secs = "0" + secs
        else secs = "" + secs
        return "" + year + '-' + month + '-' + day + 'T' + hours + ':' + mins + ':' + secs
    },
    getAreaInfo(callback) {
      this.tables.area_info.areaList = []
      var wheres = []
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.area_info.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.area_info.areaList = response.data.rows
            // 版面調整
            if(this.tables.area_info.areaList.length < 8) {
              for(var idx = this.tables.area_info.areaList.length; idx < 8; idx+=1) {
                //this.areaList.push({area_id:'DUMMY'+idx, area_nm: ''})
              }
            }

            this.tables.area_info.area_checked = []
            this.tables.area_info.areaList.forEach(area => {
              if(area.area_id != 999){
                this.tables.area_info.area_checked.push(area.area_id)
              }
            })
            
            if (callback) callback()
          }
        })
    },
    // 簡易輸入防抖機制
    tryGetRealTimeAlertPageData () {
      if (this.tables.area_info.area_checked_timer) {
        clearTimeout(this.tables.area_info.area_checked_timer)
      }
      this.tables.area_info.area_checked_timer = setTimeout(() => {
        // get data
        this.getPageData() 
      }, 500)
    }
  }
}
</script>
